// src/data/contentIdeas.js
// Content Idea Bank for Hermod's Path — recurring post ideas organised by content type

export const CONTENT_IDEAS = [
  // ── Mini-Museum (12 ideas) ──
  {
    id: 'mm-01',
    contentType: 'Mini-Museum',
    title: 'New Exhibition Launch',
    description: 'Announce the new monthly Mini-Museum exhibition theme and artifacts.',
    suggestedPlatforms: ['professional-ig', 'lux-libris-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'New Mini-Museum exhibition this month: [THEME]\nFeatures [NUMBER] authentic artifacts from [SOURCE]\nStudents can explore [KEY LEARNING OUTCOMES]\nOpen during library hours all month',
  },
  {
    id: 'mm-02',
    contentType: 'Mini-Museum',
    title: 'Behind the Scenes',
    description: 'Show the process of sourcing and setting up artifacts for the exhibition.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Setting up the new [THEME] Mini-Museum\nArtifacts sourced from [WHERE]\nProcess: [UNPACKING, ARRANGING, LABELLING]\nTook [TIME] to set up',
  },
  {
    id: 'mm-03',
    contentType: 'Mini-Museum',
    title: 'Artifact Spotlight',
    description: 'Close-up of one artifact with its story and historical context.',
    suggestedPlatforms: ['professional-ig', 'lux-libris-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Artifact spotlight: [ITEM NAME]\nFrom [ORIGIN/ERA]\nFun fact: [INTERESTING DETAIL]\nStudents love this one because [REASON]',
  },
  {
    id: 'mm-04',
    contentType: 'Mini-Museum',
    title: 'Student Reactions',
    description: 'Capture student wonder — "overheard in the museum" quotes and engagement.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Students exploring the [THEME] exhibition today\nOverheard: "[STUDENT QUOTE]"\nFavourite reactions from [GRADE LEVEL]\nMost popular artifact: [ITEM]',
  },
  {
    id: 'mm-05',
    contentType: 'Mini-Museum',
    title: 'Curriculum Connection',
    description: 'How the current exhibition links to classroom learning and standards.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'This month\'s Mini-Museum connects to [SUBJECT/STANDARD]\nTeachers are using it for [LESSON TOPIC]\n[GRADE] students exploring [CONCEPT] through real artifacts\nCross-curricular connections: [LIST]',
  },
  {
    id: 'mm-06',
    contentType: 'Mini-Museum',
    title: 'Museum vs Our Mini-Museum',
    description: 'Side-by-side comparison showing real museum parallels to our school exhibition.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'The [REAL MUSEUM] has [ARTIFACT TYPE]\nOur Mini-Museum has [OUR VERSION]\nSame learning, zero field trip cost\nBringing museum experiences to every student, every day',
  },
  {
    id: 'mm-07',
    contentType: 'Mini-Museum',
    title: 'Family Invitation',
    description: 'Invite parents and families to visit the current Mini-Museum exhibition.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Families, come visit the [THEME] Mini-Museum!\nOpen during [HOURS]\nAsk your child about [CONVERSATION STARTER]\nLocated in the school library',
  },
  {
    id: 'mm-08',
    contentType: 'Mini-Museum',
    title: 'Student Curator Reviews',
    description: 'Student Museum Curator form results — kids evaluating and rating the display.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Our student curators reviewed the [THEME] exhibition\nAverage rating: [SCORE]/5\nFavourite artifact: [ITEM]\nSuggestions for next month: [IDEAS]\n[NUMBER] curator forms submitted',
  },
  {
    id: 'mm-09',
    contentType: 'Mini-Museum',
    title: 'Did You Know?',
    description: 'Historical context and surprising facts related to the current exhibition.',
    suggestedPlatforms: ['professional-ig', 'lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Did you know? [SURPRISING FACT]\nThis connects to our [THEME] Mini-Museum\n[HISTORICAL CONTEXT]\nCome see the real artifact in person!',
  },
  {
    id: 'mm-10',
    contentType: 'Mini-Museum',
    title: 'Full Exhibition Carousel',
    description: 'Photo carousel showing the complete exhibition setup from multiple angles.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Full exhibition tour: [THEME] Mini-Museum\nSwipe through all [NUMBER] artifacts\nEach display includes [DETAILS]\nThis month\'s exhibition runs through [DATE]',
  },
  {
    id: 'mm-11',
    contentType: 'Mini-Museum',
    title: 'Mini Museum Website',
    description: 'Drive traffic to the online version at minimuseumproject.org.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Can\'t visit in person? Explore the Mini Museum online\nminimuseumproject.org\nVirtual exhibitions, resources, and more\nTeacher/librarian resources available for download',
  },
  {
    id: 'mm-12',
    contentType: 'Mini-Museum',
    title: 'Teacher/Librarian Resources',
    description: 'Highlight downloadable resources available on the Mini Museum website.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Free resources for educators on minimuseumproject.org\n[RESOURCE TYPE] now available\nPerfect for [SUBJECT/GRADE]\nDownload and adapt for your own library/classroom',
  },

  // ── Everything-Arium (9 ideas) ──
  {
    id: 'ea-01',
    contentType: 'Everything-Arium',
    title: 'New Show Announcement',
    description: 'Announce what environment the Everything-Arium is visiting next.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'New Everything-Arium show: [ENVIRONMENT]\nStudents will experience [DESCRIPTION]\nAvailable for [GRADES]\nBookings open for [DATES]',
  },
  {
    id: 'ea-02',
    contentType: 'Everything-Arium',
    title: 'Student Reactions',
    description: 'Capture the gasps, wonder, and engagement during a show.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: '[GRADE] students just experienced [ENVIRONMENT]\nThe gasps when [MOMENT]\nStudent quote: "[REACTION]"\n[NUMBER] classes have visited so far this term',
  },
  {
    id: 'ea-03',
    contentType: 'Everything-Arium',
    title: 'Behind the Scenes',
    description: 'How the five-projector setup works and the tech behind the magic.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Behind the scenes of the Everything-Arium\nFive projectors create [EFFECT]\nSoftware: [TOOLS USED]\nSetup process: [DESCRIPTION]\nThe tech that makes the magic happen',
  },
  {
    id: 'ea-04',
    contentType: 'Everything-Arium',
    title: 'Equity & Access',
    description: 'Why a planetarium in a school library matters — the equity angle.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Why does a school library have a planetarium?\nMost of our students will never visit a real planetarium\nEquity means bringing experiences TO students\nEvery child deserves wonder and discovery',
  },
  {
    id: 'ea-05',
    contentType: 'Everything-Arium',
    title: 'Teacher Feedback',
    description: 'Teacher reactions and how they integrate shows into curriculum.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Teacher feedback on the [ENVIRONMENT] show\n"[TEACHER QUOTE]"\nCurriculum connections: [SUBJECT/STANDARD]\nTeachers are using it as a launchpad for [LESSON]',
  },
  {
    id: 'ea-06',
    contentType: 'Everything-Arium',
    title: 'Technical Breakdown',
    description: 'Deep dive into the filming, editing, and Adobe workflow.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'How we build an Everything-Arium show\nFilming: [CAMERA/TECHNIQUE]\nEditing: [SOFTWARE/PROCESS]\nProjection mapping: [DETAILS]\nTotal production time: [HOURS]',
  },
  {
    id: 'ea-07',
    contentType: 'Everything-Arium',
    title: 'FACTS Innovation Award',
    description: 'The story of how the Everything-Arium was recognised nationally.',
    suggestedPlatforms: ['linkedin', 'professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'The Everything-Arium won the FACTS Innovation Award\nRecognised for [CRITERIA]\nWhat this means for school library innovation\nFrom idea to national recognition: the journey',
  },
  {
    id: 'ea-08',
    contentType: 'Everything-Arium',
    title: 'Cost Comparison',
    description: 'Field trip vs Everything-Arium — making the case for in-school experiences.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'A field trip to a planetarium costs $[AMOUNT] per student\nThe Everything-Arium costs nothing for families\nNo permission slips, no bus logistics\nEvery student gets the experience, not just those who can afford it',
  },
  {
    id: 'ea-09',
    contentType: 'Everything-Arium',
    title: 'Seasonal Show',
    description: 'Feature a seasonal or themed show (space at Christmas, ocean in summer, etc.).',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'seasonal',
    exampleBullets: 'Seasonal Everything-Arium show: [THEME]\nPerfect for [SEASON/HOLIDAY]\nStudents will experience [DESCRIPTION]\nRunning through [DATES]',
  },

  // ── Bird Window / St. Felix Nature Window (9 ideas) ──
  {
    id: 'bw-01',
    contentType: 'Bird Window Update',
    title: 'New Bird Spotted',
    description: 'A new bird species was spotted this week at the Nature Window.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'New bird spotted at the St. Felix Nature Window!\n[BIRD SPECIES]\nSpotted by [STUDENT/CLASS]\nFun fact: [BIRD FACT]\nALWAYS use real photo/video',
  },
  {
    id: 'bw-02',
    contentType: 'Bird Window Update',
    title: 'Weekly Bird ID Challenge',
    description: 'Challenge students to identify this week\'s mystery bird.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'Weekly Bird ID Challenge!\nCan you identify this bird?\nHint: [CLUE ABOUT THE BIRD]\nAnswer revealed on [DAY]\nALWAYS use real photo',
  },
  {
    id: 'bw-03',
    contentType: 'Bird Window Update',
    title: 'Seasonal Migration Update',
    description: 'Report on seasonal bird migration patterns observed at the window.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'seasonal',
    exampleBullets: 'Migration season at the Nature Window!\n[SPECIES] are [ARRIVING/DEPARTING]\nWe\'ve spotted [NUMBER] new species this [SEASON]\nStudents tracking patterns in their nature journals',
  },
  {
    id: 'bw-04',
    contentType: 'Bird Window Update',
    title: 'Student Nature Journals',
    description: 'Showcase student nature journal entries and observations.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Student nature journal spotlight\n[STUDENT] observed [BIRD/BEHAVIOUR]\nBeautiful sketches and observations\nBuilding real science skills through observation',
  },
  {
    id: 'bw-05',
    contentType: 'Bird Window Update',
    title: 'Nature Photography',
    description: 'Gentle nature photography or video captured from the window.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'A quiet moment at the St. Felix Nature Window\n[DESCRIPTION OF SCENE]\nCapture from this [MORNING/AFTERNOON]\nNature right outside our library',
  },
  {
    id: 'bw-06',
    contentType: 'Bird Window Update',
    title: 'Science Curriculum Connection',
    description: 'How the Nature Window connects to habitats, ecosystems, and migration units.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'The Nature Window as a science classroom\nConnecting to [CURRICULUM STANDARD]\n[GRADE] studying [TOPIC] using real observations\nFrom window to worksheet: authentic learning',
  },
  {
    id: 'bw-07',
    contentType: 'Bird Window Update',
    title: 'Meet Our Regulars',
    description: 'Profile the birds that visit the window consistently.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Meet our regulars at the Nature Window\n[BIRD NAME/SPECIES] visits almost every day\nStudents have named them [NICKNAME]\nFun fact: [DETAIL]\nALWAYS use real photo',
  },
  {
    id: 'bw-08',
    contentType: 'Bird Window Update',
    title: 'St. Felix Connection',
    description: 'Why the window is named after St. Felix, patron saint of animals.',
    suggestedPlatforms: ['professional-ig', 'lux-libris-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'Why is it called the St. Felix Nature Window?\nSt. Felix is the patron saint of animals\nConnecting our Catholic identity to nature stewardship\nEvery bird visit is a small blessing',
  },
  {
    id: 'bw-09',
    contentType: 'Bird Window Update',
    title: 'Bird Window Video',
    description: 'Share a video clip from the bird window camera.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'Live from the St. Felix Nature Window\n[DESCRIPTION OF VIDEO CLIP]\nWatch [BIRD] doing [BEHAVIOUR]\nNature\'s show, every day in our library',
  },

  // ── Saturday Opening (7 ideas) ──
  {
    id: 'so-01',
    contentType: 'Saturday Opening',
    title: 'Invitation Post',
    description: 'Announce the upcoming Saturday Opening — date, time, and what\'s planned.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Join us this Saturday!\nDate: [DATE]\nTime: [TIME]\nProgramme: [ACTIVITIES]\nAll Holy Family families welcome',
  },
  {
    id: 'so-02',
    contentType: 'Saturday Opening',
    title: 'Recap Photos',
    description: 'Photo highlights from the Saturday Opening event.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Saturday Opening recap!\n[NUMBER] families attended\nHighlights: [ACTIVITIES]\nThank you to everyone who came\nNext Saturday Opening: [DATE]',
  },
  {
    id: 'so-03',
    contentType: 'Saturday Opening',
    title: 'Family Engagement Highlights',
    description: 'Spotlight moments of families engaging with library programmes.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'monthly',
    exampleBullets: 'Families exploring the library together\n[ACTIVITY] was a huge hit\nParents and children [DOING WHAT]\nThis is what community looks like',
  },
  {
    id: 'so-04',
    contentType: 'Saturday Opening',
    title: 'Cultural Programming Spotlight',
    description: 'Feature special cultural events (Burns Day, book signings, etc.).',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Special programming this Saturday: [EVENT]\n[DESCRIPTION OF CULTURAL ELEMENT]\nFeaturing [SPECIAL GUEST/ACTIVITY]\nCelebrating [CULTURE/TRADITION] through our library',
  },
  {
    id: 'so-05',
    contentType: 'Saturday Opening',
    title: 'Why We Open on Saturdays',
    description: 'The community-building philosophy behind Saturday library access.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'Why does our school library open on Saturdays?\nBecause libraries belong to families, not just school hours\nBuilding community one Saturday at a time\n[NUMBER] families served since we started',
  },
  {
    id: 'so-06',
    contentType: 'Saturday Opening',
    title: 'Parent Testimonials',
    description: 'Share parent reactions and testimonials from Saturday events.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Parent feedback from Saturday Opening:\n"[PARENT QUOTE]"\nWhat families love most: [HIGHLIGHT]\nThis is why we keep the doors open',
  },
  {
    id: 'so-07',
    contentType: 'Saturday Opening',
    title: 'Attendance Milestone',
    description: 'Celebrate reaching an attendance milestone for Saturday Openings.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: '[NUMBER] families have visited our Saturday Openings!\nMilestone reached on [DATE]\nStarted [WHEN] with just [ORIGINAL NUMBER]\nGrowing our community every month',
  },

  // ── Lux Libris (15 ideas) ──
  {
    id: 'll-01',
    contentType: 'Lux Libris',
    title: 'Saint Card Reveal',
    description: 'Feature this week\'s or month\'s highlighted saint card illustration.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'saint_card',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'Meet this week\'s featured saint: [SAINT NAME]\nFeast day: [DATE]\nKnown for: [BRIEF BIO]\nCollect their card on Lux Libris!',
  },
  {
    id: 'll-02',
    contentType: 'Lux Libris',
    title: 'Badge Spotlight',
    description: 'Feature the weekly bird badge with fun facts about the bird.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'badge',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'This week\'s reading badge: [BADGE NAME]\n[BIRD] fun fact: [FACT]\nEarn it by completing your weekly reading streak\n[NUMBER] students have earned this badge so far',
  },
  {
    id: 'll-03',
    contentType: 'Lux Libris',
    title: 'Reading Milestone Celebration',
    description: 'Celebrate a student or class hitting a reading milestone.',
    suggestedPlatforms: ['lux-libris-ig', 'professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Reading milestone!\n[STUDENT/CLASS] just hit [NUMBER] books\nTotal school reading: [TOTAL] books this year\nForming saints, one book at a time',
  },
  {
    id: 'll-04',
    contentType: 'Lux Libris',
    title: 'Luxlings Series Reveal',
    description: 'Reveal or spotlight a Luxlings series collection.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Luxlings Series Spotlight: [SERIES NAME]\n[NUMBER] books in this collection\nPerfect for readers who love [GENRE/THEME]\nStart collecting today!',
  },
  {
    id: 'll-05',
    contentType: 'Lux Libris',
    title: 'Feature Walkthrough',
    description: 'Walk through a Lux Libris feature (bookshelves, battles, badges, etc.).',
    suggestedPlatforms: ['lux-libris-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Feature walkthrough: [FEATURE NAME]\nHow it works: [STEP BY STEP]\nStudents love this because [REASON]\nTry it at luxlibris.org',
  },
  {
    id: 'll-06',
    contentType: 'Lux Libris',
    title: 'Voting Phase Update',
    description: 'Update on the April-May student voting phase for next year\'s booklist.',
    suggestedPlatforms: ['lux-libris-ig', 'professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'seasonal',
    exampleBullets: 'Voting is OPEN!\nStudents are choosing next year\'s Lux Libris booklist\n[NUMBER] votes cast so far\nCurrent leaders: [TOP PICKS]\nVoting closes [DATE]',
  },
  {
    id: 'll-07',
    contentType: 'Lux Libris',
    title: 'New Booklist Announcement',
    description: 'Announce the new annual booklist (June 1 each year).',
    suggestedPlatforms: ['lux-libris-ig', 'professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'The new Lux Libris booklist is HERE!\n[NUMBER] new titles for [SCHOOL YEAR]\nHighlights: [TOP PICKS]\nStudents voted and we listened\nAvailable June 1 at luxlibris.org',
  },
  {
    id: 'll-08',
    contentType: 'Lux Libris',
    title: 'School Adoption News',
    description: 'Announce new schools joining the Lux Libris platform.',
    suggestedPlatforms: ['lux-libris-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Welcome to the Lux Libris family!\n[SCHOOL NAME] in [LOCATION] just joined\nNow serving [TOTAL NUMBER] schools\nForming saints across the country',
  },
  {
    id: 'll-09',
    contentType: 'Lux Libris',
    title: 'Seasonal Bookshelf Theme',
    description: 'Showcase the seasonal or liturgical bookshelf theme change.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'seasonal',
    exampleBullets: 'New seasonal bookshelf: [THEME/SEASON]\nBeautiful [LITURGICAL SEASON] design\nStudents\' bookshelves update automatically\nCollect books to fill your shelf!',
  },
  {
    id: 'll-10',
    contentType: 'Lux Libris',
    title: 'Reading DNA Spotlight',
    description: 'Feature a Reading DNA personality type with fun details.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'What\'s your Reading DNA?\nSpotlight: [PERSONALITY TYPE]\nTraits: [CHARACTERISTICS]\nBest genres for this type: [GENRES]\nDiscover yours at luxlibris.org',
  },
  {
    id: 'll-11',
    contentType: 'Lux Libris',
    title: 'Jane Austen Battle Moment',
    description: 'Feature a Jane Austen Battle mascot image (battle-ready, encouraging, prayerful, victorious).',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Jane Austen Battle update!\n[BATTLE STATUS/RESULT]\nStudents are [COMPETING/CELEBRATING]\nMascot mood: [BATTLE-READY/ENCOURAGING/PRAYERFUL/VICTORIOUS]',
  },
  {
    id: 'll-12',
    contentType: 'Lux Libris',
    title: 'Demo / School Walkthrough',
    description: 'Show Lux Libris in action for interested schools and administrators.',
    suggestedPlatforms: ['lux-libris-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Want to see Lux Libris in action?\n[FEATURE/SCREEN] walkthrough\nHere\'s what students see when they [ACTION]\nInterested schools: DM us or visit luxlibris.org',
  },
  {
    id: 'll-13',
    contentType: 'Lux Libris',
    title: 'Parent Guide',
    description: 'Help parents understand and support their child on Lux Libris.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Parent guide: Supporting your child on Lux Libris\nTip 1: [TIP]\nTip 2: [TIP]\nTip 3: [TIP]\nLog in together at luxlibris.org',
  },
  {
    id: 'll-14',
    contentType: 'Lux Libris',
    title: 'Trophy Case Showcase',
    description: 'Show off the seasonal trophy case designs and student achievements.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'seasonal',
    exampleBullets: 'Trophy Case spotlight: [SEASON] edition\n[NUMBER] students have earned trophies\nTop achievements: [LIST]\nKeep reading to fill your case!',
  },
  {
    id: 'll-15',
    contentType: 'Lux Libris',
    title: 'Streak Celebration',
    description: 'Celebrate students maintaining reading streaks.',
    suggestedPlatforms: ['lux-libris-ig'],
    suggestedImageType: 'badge',
    suggestedAsset: null,
    frequency: 'weekly',
    exampleBullets: 'Streak celebration!\n[NUMBER] students on a [WEEKS]-week reading streak\nThis week\'s badge: [BADGE NAME]\nKeep the streak alive!',
  },

  // ── Publishing House (9 ideas) ──
  {
    id: 'ph-01',
    contentType: 'Publishing House',
    title: 'Book Launch Announcement',
    description: 'Announce a new student-published book.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'NEW BOOK LAUNCH!\nTitle: [BOOK TITLE]\nAuthor: [STUDENT NAME], 8th Grade\nGenre: [GENRE]\nISBN: [NUMBER]\nAvailable now through the Publishing House',
  },
  {
    id: 'ph-02',
    contentType: 'Publishing House',
    title: 'Author Spotlight',
    description: 'Profile a student author — their journey and inspiration.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Author spotlight: [STUDENT NAME]\nTheir book: [TITLE]\nInspiration: [WHAT INSPIRED THEM]\nFavourite part of being published: [QUOTE]',
  },
  {
    id: 'ph-03',
    contentType: 'Publishing House',
    title: 'Editing Process',
    description: 'Behind-the-scenes of the student book editing and production process.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Behind the scenes at the Publishing House\nEditing stage: [DESCRIPTION]\nStudents learning [SKILL]\nFrom draft to published book: the journey',
  },
  {
    id: 'ph-04',
    contentType: 'Publishing House',
    title: 'ISBN Milestone',
    description: 'Celebrate the ISBN registration milestone — students are real published authors.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Our students are PUBLISHED authors\n[NUMBER] books now have ISBN numbers\nReal ISBNs. Real published books. Real authors.\nAll before high school.',
  },
  {
    id: 'ph-05',
    contentType: 'Publishing House',
    title: 'Book Cover Reveal',
    description: 'Reveal a student-designed book cover.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'COVER REVEAL!\n[BOOK TITLE] by [STUDENT]\nCover designed by [STUDENT/DESIGNER]\nComing soon from the Publishing House',
  },
  {
    id: 'ph-06',
    contentType: 'Publishing House',
    title: 'Writing Workshop',
    description: 'Highlight from a writing workshop or masterclass session.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Writing workshop today!\nTopic: [WORKSHOP FOCUS]\nStudents learned [SKILL]\nWriting is a superpower we can all develop',
  },
  {
    id: 'ph-07',
    contentType: 'Publishing House',
    title: 'Student Reflections',
    description: 'Student reflections on the experience of being published.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'What does it feel like to be a published author at [AGE]?\n[STUDENT] says: "[QUOTE]"\nThe confidence this gives our students is immeasurable\nEvery child has a story worth telling',
  },
  {
    id: 'ph-08',
    contentType: 'Publishing House',
    title: 'What I Learned',
    description: 'Student authors share their biggest takeaways from the publishing process.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: '"What I learned from publishing my book"\n[STUDENT]: "[LESSON 1]"\n[STUDENT]: "[LESSON 2]"\nSkills that last a lifetime',
  },
  {
    id: 'ph-09',
    contentType: 'Publishing House',
    title: 'Launch Event Photos',
    description: 'Photos from a book launch or reading event.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Book launch event for [TITLE]!\n[STUDENT] read to [AUDIENCE]\n[NUMBER] attendees\nProud families celebrating young authors',
  },

  // ── Mini-Modern (6 ideas) ──
  {
    id: 'mod-01',
    contentType: 'Mini-Modern',
    title: 'New Installation Reveal',
    description: 'Reveal a new Mini-Modern art installation in the library.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'New Mini-Modern installation: [TITLE/THEME]\nCreated by [ARTIST/CLASS]\nMaterials: [MATERIALS USED]\nOn display in the library through [DATE]',
  },
  {
    id: 'mod-02',
    contentType: 'Mini-Modern',
    title: 'Student Artist Spotlight',
    description: 'Profile a student artist and their creative process.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Student artist spotlight: [STUDENT]\nTheir installation: [DESCRIPTION]\nInspiration: [WHAT INSPIRED THEM]\n"[ARTIST QUOTE]"',
  },
  {
    id: 'mod-03',
    contentType: 'Mini-Modern',
    title: 'Creative Process',
    description: 'Document the creative process of making an installation.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Behind the scenes: making [INSTALLATION]\nStep 1: [PROCESS]\nStep 2: [PROCESS]\nFrom concept to installation: [TIME]',
  },
  {
    id: 'mod-04',
    contentType: 'Mini-Modern',
    title: 'Art Meets Library',
    description: 'Why visual art belongs in libraries — the intersection of creativity and learning.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Why does a school library have an art gallery?\nBecause creativity and literacy are inseparable\nArt makes the library a living, breathing space\nStudents engage differently when surrounded by beauty',
  },
  {
    id: 'mod-05',
    contentType: 'Mini-Modern',
    title: 'Visitor Reactions',
    description: 'Capture reactions from visitors seeing the installation.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Reactions to [INSTALLATION NAME]\n"[VISITOR QUOTE]"\nStudents: [REACTIONS]\nArt sparking conversation in the library',
  },
  {
    id: 'mod-06',
    contentType: 'Mini-Modern',
    title: 'Materials & Techniques',
    description: 'Explain the materials and techniques used in an installation.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Materials spotlight: [INSTALLATION]\nMade from: [MATERIALS]\nTechnique: [METHOD]\nFun fact: [INTERESTING DETAIL ABOUT PROCESS]',
  },

  // ── MS Research Center (6 ideas) ──
  {
    id: 'ms-01',
    contentType: 'MS Research Center',
    title: 'Space Reveal',
    description: 'Show off the completed MS Research Center space.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'The MS Research Center is OPEN!\nDedicated space for middle school research\nFeatures: [LIST OF FEATURES]\nDesigned for [PURPOSE]',
  },
  {
    id: 'ms-02',
    contentType: 'MS Research Center',
    title: 'Geology Specimen Spotlight',
    description: 'Feature an individual geology specimen with facts.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Specimen spotlight: [SPECIMEN NAME]\nType: [ROCK/MINERAL/FOSSIL]\nOrigin: [WHERE FROM]\nFun fact: [GEOLOGICAL FACT]\nPart of our [NUMBER]-piece collection',
  },
  {
    id: 'ms-03',
    contentType: 'MS Research Center',
    title: 'Research Skills in Action',
    description: 'Show middle schoolers actively using the research space.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Research skills in action!\n[GRADE] students researching [TOPIC]\nUsing [RESOURCES/DATABASES]\nBuilding skills they\'ll need in high school and beyond',
  },
  {
    id: 'ms-04',
    contentType: 'MS Research Center',
    title: 'Transformation Story',
    description: '"From cardboard boxes to research center" — the before and after.',
    suggestedPlatforms: ['professional-ig', 'linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'From cardboard boxes to a dedicated Research Center\nBefore: [WHAT IT WAS]\nAfter: [WHAT IT IS NOW]\nEvery student deserves a space designed for discovery',
  },
  {
    id: 'ms-05',
    contentType: 'MS Research Center',
    title: 'Collection Development',
    description: 'New additions to the geology or reference collection.',
    suggestedPlatforms: ['professional-ig'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'New additions to the Research Center!\n[NUMBER] new [SPECIMENS/RESOURCES]\nIncluding: [HIGHLIGHTS]\nOur collection now includes [TOTAL] pieces',
  },
  {
    id: 'ms-06',
    contentType: 'MS Research Center',
    title: 'Middle School vs Elementary',
    description: 'How the Research Center differs from and complements the elementary library.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'one-time',
    exampleBullets: 'Why does middle school need its own space?\nElementary library: [FOCUS]\nMS Research Center: [FOCUS]\nDevelopmentally appropriate, academically rigorous\nMeeting students where they are',
  },

  // ── Professional Development (8 ideas) ──
  {
    id: 'pd-01',
    contentType: 'Professional Development',
    title: 'Session Announcement',
    description: 'Announce an upcoming PD session for librarians.',
    suggestedPlatforms: ['linkedin', 'professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Upcoming PD session: [TOPIC]\nDate: [DATE]\nAudience: [WHO IT\'S FOR]\nKey takeaways: [WHAT PARTICIPANTS WILL LEARN]',
  },
  {
    id: 'pd-02',
    contentType: 'Professional Development',
    title: 'Key Takeaways',
    description: 'Share slide highlights and key takeaways from a recent PD session.',
    suggestedPlatforms: ['linkedin', 'professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Key takeaways from today\'s PD on [TOPIC]\n1. [TAKEAWAY]\n2. [TAKEAWAY]\n3. [TAKEAWAY]\n[NUMBER] librarians participated',
  },
  {
    id: 'pd-03',
    contentType: 'Professional Development',
    title: 'Participant Reactions',
    description: 'Share feedback and ratings from PD participants.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'PD feedback from [SESSION NAME]\nAverage rating: [SCORE]/5\n"[PARTICIPANT QUOTE]"\n"[PARTICIPANT QUOTE]"\n[NUMBER] participants would recommend this session',
  },
  {
    id: 'pd-04',
    contentType: 'Professional Development',
    title: 'One Thing You Can Implement',
    description: 'A single practical tip from a PD session that anyone can use tomorrow.',
    suggestedPlatforms: ['linkedin', 'professional-ig'],
    suggestedImageType: 'graphic',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'One thing you can implement TOMORROW:\n[PRACTICAL TIP]\nWhy it works: [REASON]\nTakes [TIME] to set up\nFrom our PD on [TOPIC]',
  },
  {
    id: 'pd-05',
    contentType: 'Professional Development',
    title: 'Behind the Scenes: Preparing PD',
    description: 'What goes into preparing a professional development session.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'photo',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'Behind the scenes: preparing PD on [TOPIC]\n[HOURS] of preparation\nResearch sources: [REFERENCES]\nMy goal: [WHAT I WANT PARTICIPANTS TO LEAVE WITH]',
  },
  {
    id: 'pd-06',
    contentType: 'Professional Development',
    title: 'What Librarians Need Most',
    description: 'Reflection on the most common needs and challenges facing librarians.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'none',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'After [NUMBER] PD sessions, here\'s what librarians ask for most:\n1. [NEED]\n2. [NEED]\n3. [NEED]\nWe need to listen and respond to these needs',
  },
  {
    id: 'pd-07',
    contentType: 'Professional Development',
    title: 'Librarians Are Undervalued',
    description: 'Advocacy angle — making the case for librarian value and investment.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'none',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'School librarians are the most underutilised professionals in education\n[STATISTIC OR EXAMPLE]\nWhat happens when you invest in your librarian: [OUTCOMES]\nAdvocacy starts with visibility',
  },
  {
    id: 'pd-08',
    contentType: 'Professional Development',
    title: 'Empowerment Narrative',
    description: '"You are not JUST a librarian" — empowering the profession.',
    suggestedPlatforms: ['linkedin'],
    suggestedImageType: 'none',
    suggestedAsset: null,
    frequency: 'as-needed',
    exampleBullets: 'You are not JUST a librarian\nYou are [ROLE 1]\nYou are [ROLE 2]\nYou are [ROLE 3]\nNever let anyone reduce what you do to "just" anything',
  },
];

/**
 * Get ideas filtered by content type
 * @param {string} [contentType] - Content type to filter by, or null/undefined for all
 * @returns {Array} Filtered ideas
 */
export function getIdeasByType(contentType) {
  if (!contentType || contentType === 'General') return CONTENT_IDEAS;
  return CONTENT_IDEAS.filter(idea => idea.contentType === contentType);
}

/**
 * Get all unique content types that have ideas
 * @returns {string[]}
 */
export function getIdeaContentTypes() {
  return [...new Set(CONTENT_IDEAS.map(idea => idea.contentType))];
}
